
<template>
  <div class="container-single-rate">
    <div class="options-single-rate" v-if="isStar">
      <button class="btn-star-single"
        :class="`option-${bt.id}${questionId} is-${questionId}`"
        v-for="bt in items"
        :key="bt.value"
        :style="{
          'width': screenX < 700 && lengthOptions > 7 ? '4rem' : '6.5rem',
          'height': screenX < 700 && lengthOptions > 7 ? '3.5rem' : '6.5rem',
          'margin': screenX < 700 && lengthOptions > 7 ? '0 0.2rem' : '0 0.1rem'
        }"
        @click="selectOption(bt, `.option-${bt.id}${questionId}`)">
        <Icon name="star" size="lg" class="icon-star-single rating__icon" :style="{ 'color': !isGradient ? '#ffff00' : bt.bgColor }"/>
        <p v-if="useStarNumbers" class="label-btn-star" :style="{ 'color': labelColor }">{{ bt.id }}</p>
      </button>
    </div>
    <div class="options-single-rate" v-if="!isStar">
      <button
        v-for="bt in items"
        :key="bt.value"
        class="btn-single-rate"
        :class="`option-${bt.id}${questionId} is-${questionId}`"
        :style="{
          'background': !isGradient ? bgColor : bt.bgColor,
          'color': labelColor,
          'width': screenX < 700 && lengthOptions > 7 ? '4rem' : '4.5rem',
          'height': screenX < 700 && lengthOptions > 7 ? '3.5rem' : '4.5rem',
          'margin': screenX < 700 && lengthOptions > 7 ? '0 0.2rem' : '0 0.1rem'
        }"
        @click="selectOption(bt, `.option-${bt.id}${questionId}`)"
        >{{ bt.id }}</button>
    </div>
    <div class="labels-single-rate">
      <p class="start-label" :style="{'color': textColor }">{{ startLabel }}</p>
      <p class="end-label" :style="{'color': textColor }">{{ endLabel }}</p>
    </div>
  </div>
</template>

<script>
import Icon from '../Icon/Icon.vue'
import { gradientMaker } from '../../_helpers/gradientColors'

export default {
  name: 'SingleRate',
  status: 'prototype',
  release: '1.0.0',
  components: { Icon },
  props: {
    questionId: {
      type: String
    },
    questionType: {
      type: String
    },
    questionUi: {
      type: String
    },
    lengthOptions: {
      type: Number
    },
    showNumber: {
      type: Boolean,
      default: true
    },
    isStar: {
      type: Boolean,
      default: false
    },
    useStarNumbers: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: '#242424'
    },
    isGradient: {
      type: Boolean,
      default: true
    },
    bgColor: {
      type: String
    },
    hoverColor: {
      type: String
    },
    labelColor: {
      type: String,
      default: 'value'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    startLabel: {
      type: String,
      default: ''
    },
    endLabel: {
      type: String,
      default: ''
    },
    rating: {
      type: String
    }
  },
  data () {
    return {
      screenX: '',
      labels: null,
      items: [],
      mappedOptions: {
        csat: {
          '5num': [
            { id: 1, value: 0 },
            { id: 2, value: 25 },
            { id: 3, value: 50 },
            { id: 4, value: 75 },
            { id: 5, value: 100 }
          ],
          '10num': [
            { id: 0, value: 0 },
            { id: 1, value: 10 },
            { id: 2, value: 20 },
            { id: 3, value: 30 },
            { id: 4, value: 40 },
            { id: 5, value: 50 },
            { id: 6, value: 60 },
            { id: 7, value: 70 },
            { id: 8, value: 80 },
            { id: 9, value: 90 },
            { id: 10, value: 100 }
          ]
        },
        ces: {
          '1to7': [
            { id: 1, value: 0 },
            { id: 2, value: 15 },
            { id: 3, value: 30 },
            { id: 4, value: 50 },
            { id: 5, value: 65 },
            { id: 6, value: 80 },
            { id: 7, value: 100 }
          ]
        },
        nps: {
          '10num': [
            { id: 0, value: 0 },
            { id: 1, value: 10 },
            { id: 2, value: 20 },
            { id: 3, value: 30 },
            { id: 4, value: 40 },
            { id: 5, value: 50 },
            { id: 6, value: 60 },
            { id: 7, value: 70 },
            { id: 8, value: 80 },
            { id: 9, value: 90 },
            { id: 10, value: 100 }
          ]
        },
        nes: {
          '10num': [
            { id: 1, value: 0 },
            { id: 2, value: 25 },
            { id: 3, value: 50 },
            { id: 4, value: 75 },
            { id: 5, value: 100 }
          ]
        },
        enum: {
          6: [
            { id: 0, value: 0 },
            { id: 1, value: 1 },
            { id: 2, value: 2 },
            { id: 3, value: 3 },
            { id: 4, value: 4 },
            { id: 5, value: 5 }
          ],
          5: [
            { id: 1, value: 1 },
            { id: 2, value: 2 },
            { id: 3, value: 3 },
            { id: 4, value: 4 },
            { id: 5, value: 5 }
          ],
          11: [
            { id: 0, value: 0 },
            { id: 1, value: 1 },
            { id: 2, value: 2 },
            { id: 3, value: 3 },
            { id: 4, value: 4 },
            { id: 5, value: 5 },
            { id: 6, value: 6 },
            { id: 7, value: 7 },
            { id: 8, value: 8 },
            { id: 9, value: 9 },
            { id: 10, value: 10 }
          ],
          10: [
            { id: 1, value: 1 },
            { id: 2, value: 2 },
            { id: 3, value: 3 },
            { id: 4, value: 4 },
            { id: 5, value: 5 },
            { id: 6, value: 6 },
            { id: 7, value: 7 },
            { id: 8, value: 8 },
            { id: 9, value: 9 },
            { id: 10, value: 10 }
          ]
        }
      }
    }
  },
  mounted () {
    setInterval(() => {
      this.screenX = window.screen.availWidth
    }, 500)

    if (this.questionType === 'enum' && this.questionUi === '10num') {
      this.items = this.mappedOptions.enum[this.lengthOptions]
    } else {
      this.items = this.mappedOptions[this.questionType][this.questionUi]
    }

    if (this.isGradient) {
      gradientMaker.checkGradientAndReturnTheColors(this.questionType, this.questionUi, this.items)
    }

    const responseOnLoad = this.items.find(e => e.value.toString() === this.rating)

    if (responseOnLoad) {
      setTimeout(() => {
        this.selectOption(responseOnLoad, `.option-${responseOnLoad.id}${this.questionId}`)
      }, 10)
    }
  },
  methods: {
    selectOption (e, btnClass) {
      const valueToSend = { rating: e.value, value: e.id }
      const buttons = document.querySelectorAll(`.is-${this.questionId}`)

      for (const child of buttons) {
        child.style.borderColor = 'transparent'
        child.style.transform = 'scale(1)'
        child.style.fontSize = '1.5rem'
        child.style.filter = 'drop-shadow(0px 0px 3px rgba(207, 207, 207, 0.649))'
      }

      const selectedButton = document.querySelector(btnClass)

      if (this.isStar) {
        selectedButton.style.filter = `drop-shadow(0px 0px 3px #f8c43d)`
      }

      selectedButton.style.filter = `drop-shadow(0px 0px 3px gray)`
      selectedButton.style.borderColor = '#000000'
      selectedButton.style.transform = 'scale(1.1)'
      selectedButton.style.fontSize = '1.7rem'

      return this.$emit('isValue', valueToSend)
    }
  }
}
</script>

<style lang="scss" scoped>
* { font-family: "Open Sans", Helvetica, Arial, sans-serif; }

:root { font-size: 62.5% !important; }

.container-single-rate {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .options-single-rate {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn-single-rate {
      width: 4.5rem;
      height: 4.5rem;
      border-radius: 50%;
      border: none;
      font-size: 1.5rem;
      margin: 0 0.4rem;
      font-weight: bold;
      user-select: none;
      cursor: pointer;
      border: 0.2rem solid transparent;
    }
    .btn-single-rate:hover {
      transform: scale(1.1);
    }
    .btn-star-single {
      position: relative;
      background: transparent;
      cursor: pointer;
      .icon-star-single {
        font-size: 60px;
        filter: drop-shadow(0px 0px 3px rgba(207, 207, 207, 0.649));
      }
      .label-btn-star {
        position: absolute;
        left: 43%;
        top: 37%;
        font-size: 1.6rem;
        font-weight: bold;
      }
    }
  }
  .labels-single-rate {
    width: 100%;
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .start-label, .end-label {
      font-size: 1.5rem;
    }
  }
}

@media only screen and (max-width: 500px) {
  .container-single-rate {
    .options-single-rate {
      .btn-single-rate {
        width: 4.5rem;
        height: 4.5rem;
        margin: 0 0.1rem;
      }

    }
    .labels-single-rate {
      width: 100%;
      margin-top: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .start-label, .end-label {
        font-size: 1.5rem;
      }
    }
  }
}
</style>
